






















import { Component, Prop, Vue , Watch } from "vue-property-decorator";
import { Const } from "@/const";
import { FontManager } from '@/model/fontManager/fontManager';

@Component({
  components: {
  },
})
export default class Export extends Vue {
    @Prop() private userConfigColor! : string;

    private get fontMamily()
    {
        var fontManager : FontManager = this.$store.getters.fontManager;
        return fontManager.getFontFamilyName(Const.UI_FONT_ID);
    }

    private get fontWeight()
    {
        return Const.UI_FONT_WEIGHT;
    }
}
